import type { Language } from './format'

export interface DisplayParams {
  placeId: string
  userId: string
  lang: Language
}

export interface ParamError {
  error: 'missing_place_id' | 'missing_user_id'
}

const LANGUAGES: readonly Language[] = ['en', 'da', 'sv', 'de', 'nb']

export function isParamError(value: DisplayParams | ParamError): value is ParamError {
  return 'error' in value
}

export function parseDisplayParams(search: string): DisplayParams | ParamError {
  const query = new URLSearchParams(search)

  const placeId = query.get('place_id')
  if (!placeId) return { error: 'missing_place_id' }

  const userId = query.get('user_id')
  if (!userId) return { error: 'missing_user_id' }

  const requested = query.get('l')
  const lang = LANGUAGES.find((l) => l === requested) ?? 'en'

  return { placeId, userId, lang }
}
